module.exports = __webpack_public_path__ + "img/arrange.88ef8655.svg";